import qs from 'qs';
import { URL_HASHES } from 'tradera/constants/url-hashes';

// Lets make TS accept title on window
declare global {
    interface Window {
        title: string;
    }
}

/**
 * Remove hash and forceRedirect param from url
 */
export const removeHashFromUrl = () => {
    const { forceRedirect, ...otherQueryParams } = qs.parse(location.search, {
        ignoreQueryPrefix: true
    });
    if (document.location.hash.length === 0 && !forceRedirect) {
        return;
    }
    const url =
        location.pathname +
        qs.stringify(otherQueryParams, { addQueryPrefix: true });
    history.replaceState({}, window.title, url);
};

export const removeQueryParametersFromUrl = () => {
    const url = location.href.replace(location.search, '');
    history.replaceState({}, window.title, url);
};

export const shouldOpenBiddingModal = () =>
    document.location.hash.includes(URL_HASHES.openBiddingModal);

export const shouldSaveInWishlist = () =>
    document.location.hash.includes(URL_HASHES.saveInWishlist);

export const shouldOpenBinModal = () =>
    document.location.hash.includes(URL_HASHES.openBinModal);

export const shouldBuyShopItem = () =>
    document.location.hash.includes(URL_HASHES.buyShopItem);

export const shouldShowRequestedCombinedShippingToast = () =>
    document.location.hash.includes(URL_HASHES.hasRequestedCombinedShipping);

export const shouldOpenReferralModal = () =>
    document.location.hash.includes(URL_HASHES.openReferralModal);

const getBaseRedirectUrl = () => {
    // Add random query parameter to force reload when redirecting to this url
    // and only the hash differs
    const queryParams = {
        ...qs.parse(location.search, { ignoreQueryPrefix: true }),
        forceRedirect: Math.round(Math.random() * 100000)
    };
    return (
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        qs.stringify(queryParams, { addQueryPrefix: true })
    );
};

export const getBiddingRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.openBiddingModal;

export const getWishlistRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.saveInWishlist;

export const getBinRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.openBinModal;

export const getShopItemRedirectUrl = () =>
    getBaseRedirectUrl() + '#' + URL_HASHES.buyShopItem;
